module.exports = "/_next/static/images/Anna_Flipchart-fcdb7abba8e2f096eda72da6466d6402.svg";